import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../../util/reactIntl';
import { LuFactory } from "react-icons/lu";
import { LuUsers } from "react-icons/lu";
import { RiSecurePaymentFill } from "react-icons/ri";
// import aboutim from "../../../assets/aboutim"

import css from './AboutSection.module.css';

/**
 * About Section component for ChinaDolphins custom homepage
 */
const AboutSection = props => {
  const { className, rootClassName } = props;
  const classes = classNames(rootClassName || css.root, className);

  // Four key features - Inspired by reference image
  const features = [
    {
      titleId: 'landing.about.feature1Title',
      descId: 'landing.about.feature1Desc',
      icon: (
        <svg viewBox="0 0 24 24" width="22" height="22" className={css.featureIcon} fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
          <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
          <line x1="12" y1="22.08" x2="12" y2="12" />
        </svg>
      ),
    },
    {
      titleId: 'landing.about.feature2Title',
      descId: 'landing.about.feature2Desc',
      icon: (
        <svg viewBox="0 0 24 24" width="22" height="22" className={css.featureIcon} fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
          <circle cx="9" cy="7" r="4" />
          <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
          <path d="M16 3.13a4 4 0 0 1 0 7.75" />
        </svg>
      ),
    },
    {
      titleId: 'landing.about.feature3Title',
      descId: 'landing.about.feature3Desc',
      icon: (
        <svg viewBox="0 0 24 24" width="22" height="22" className={css.featureIcon} fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="11" width="18" height="11" rx="2" ry="2" />
          <path d="M7 11V7a5 5 0 0 1 10 0v4" />
        </svg>
      ),
    },
    {
      titleId: 'landing.about.feature4Title',
      descId: 'landing.about.feature4Desc',
      icon: (
        <svg viewBox="0 0 24 24" width="22" height="22" className={css.featureIcon} fill="none" stroke="currentColor" strokeWidth="2">
          <polyline points="22 12 18 12 15 21 9 3 6 12 2 12" />
        </svg>
      ),
    },
  ];

  return (
   <div className={css.padding}>
    <div className={css.frame}>
      <div className={css.left}>
        
      </div>
      <div className={css.right}>
        <h1>
          <FormattedMessage id="landing.about.title" />
        </h1>
        <h3>
          <FormattedMessage id="landing.about.subtitle" />
        </h3>
        <div className={css.abouticoncard}>
          <div className={css.abouticon}>
            <div className={css.iconCircle}>
              <LuFactory size={26} color="#4169E1" />
            </div>
            <h3>
              <FormattedMessage id="landing.about.feature1Title" />
            </h3>
            <h4>
              <FormattedMessage id="landing.about.feature1Desc" />
            </h4>
          </div>
          <div className={css.abouticon}>
            <div className={css.iconCircle}>
              <LuUsers size={26} color="#4169E1" />
            </div>
            <h3>
              <FormattedMessage id="landing.about.feature2Title" />
            </h3>
            <h4>
              <FormattedMessage id="landing.about.feature2Desc" />
            </h4>
          </div>
          <div className={css.abouticon}>
            <div className={css.iconCircle}>
              <RiSecurePaymentFill size={26} color="#4169E1" />
            </div>
            <h3>
              <FormattedMessage id="landing.about.feature3Title" />
            </h3>
            <h4>
              <FormattedMessage id="landing.about.feature3Desc" />
            </h4>
          </div>
          <div className={css.abouticon}>
            <div className={css.iconCircle}>
              <LuFactory size={26} color="#4169E1" />
            </div>
            <h3>
              <FormattedMessage id="landing.about.feature4Title" />
            </h3>
            <h4>
              <FormattedMessage id="landing.about.feature4Desc" />
            </h4>
          </div>
        </div>
      </div>
    </div>
   </div>
  );
};

AboutSection.defaultProps = {
  className: null,
  rootClassName: null,
};

AboutSection.propTypes = {
  className: PropTypes.string,
  rootClassName: PropTypes.string,
};

export default AboutSection;
